<template>
    <div class="col-sm-12 mx-auto mt-3">
        <b-row>
            <b-col sm="2">
                <bulkActions :selectedRows="getSelectedRows.length"></bulkActions>
            </b-col>

            <b-col sm="6">
                <b-input-group>
                    <b-input-group-prepend is-text>
                        <font-awesome-icon icon="search" />
                    </b-input-group-prepend>

                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        :placeholder="$t('history.placeholder.TypeToSearch')"
                        :debounce="debounceValue"
                        @input="toggleBusy"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col sm="4">
                <b-pagination
                    :total-rows="tableRows"
                    v-model="currentPage"
                    :per-page="perPage"
                    align="fill"
                ></b-pagination>
                <span style="font-weight: bold;">
                    {{ $t('history.label.ShowingShipments') }} {{ paginationIndex + 1 }}-{{
                    paginationIndex + perPage > totalRows
                    ? totalRows
                    : paginationIndex + perPage
                    }}
                    {{ $t('history.label.Of') }} {{ totalRows }}
                </span>
            </b-col>
        </b-row>

        <b-table
            class="text-left"
            :items="rows"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @sort-changed="sortingChanged"
            @filtered="onFiltered"
            :filter="filter"
            :busy="isBusy"
            outlined
            fixed
        >
            <template v-slot:head(select)>
                <b-form-checkbox
                    @change="selectAll"
                    v-model="isAllSelected"
                    size="sm"
                    name="selectAllHistoryList"
                ></b-form-checkbox>
            </template>

            <template v-slot:cell(select)="data">
                <b-form-checkbox
                    size="sm"
                    @change="select(data.item)"
                    :checked="isSelected(data.item)"
                ></b-form-checkbox>
            </template>

            <template v-slot:cell(dateAwb)="data">
                <span
                    :name="'shipDate' + data.item.id"
                >{{ data.item.shipDate.substring(0, 10) }}</span>
                <br />

                <span v-if="data.item.bookingType !== BOOKING_TYPES.QUOTE_BOOKING.toString()">
                    <a 
                        :name="'trackingLink' + data.item.id"
                        :href="data.item.trackingLink"
                        target="_blank"
                    >
                        <u>{{ data.item.shipmentRef}}</u>
                    </a>
                </span>
              <span v-else>
                        <a>{{ data.item.shipmentRef}}</a>
                </span>
              
              
            </template>

            <template v-slot:row-details="row">
                <div v-if="row.item.deliveryStatus == 'Delayed'">
                    <i
                        v-if="row.item.lastTrackEventDate != null"
                    >{{ row.item.lastTrackEventDateFormatted }} - </i>
                    <i>{{ row.item.lastTrackEventMessage }}</i>
                </div>
            </template>

            <template v-slot:head(dateAwb)>
                <span>{{ $t('history.label.Date') }}</span>
                <br />
                <span>{{ $t('history.label.AWB') }}</span>
            </template>

            <template v-slot:cell(transportProduct)="data">
                {{ data.item.formattedTransportProduct }}
                <br />
                {{ data.item.salesProduct }}
            </template>

            <template v-slot:head(transportProduct)>
                <span>{{ $t('history.label.TransportProduct') }}</span>
                <br />
                <span>{{ $t('history.label.Product') }}</span>
            </template>

            <template v-slot:cell(shipFromCompanyAccount)="data">
                {{ data.item.senderName }}
                <br />
                {{ data.item.companyAccountName }}
            </template>

            <template v-slot:head(shipFromCompanyAccount)>
                <span>{{ $t('history.label.ShipFromCompany') }}</span>
                <br />
                <span>{{ $t('history.label.Account') }}</span>
            </template>

            <template v-slot:cell(shipToCompanyCountry)="data">
                {{ data.item.receiverName }}
                <br />
                {{ data.item.receiverCountryName }}
            </template>

            <template v-slot:head(shipToCompanyCountry)>
                <span>{{ $t('history.label.ShipToCompany') }}</span>
                <br />
                <span>{{ $t('history.label.Country') }}</span>
            </template>

            <template v-slot:cell(sendersReceiversReference)="data">
                <span
                    :name="'sendersReference' + data.item.id"
                >{{ data.item.sendersReference }}</span>
                <br />
                <span
                    :name="'receiversReference' + data.item.id"
                >{{ data.item.receiversReference }}</span>
            </template>

            <template v-slot:head(sendersReceiversReference)>
                <span>{{ $t('history.label.SendersReference') }}</span>
                <br />
                <span>{{ $t('history.label.ReceiversReference') }}</span>
            </template>

            <template v-slot:head(actions)>
                <span class="ml-2">{{ $t('history.label.Actions') }}</span>
            </template>

            <template v-slot:cell(actions)="data">
                <historyAction :shipment="data.item" :index="data.item.id" />
            </template>
        </b-table>

        <b-row>
            <b-col sm="2">
                <bulkActions :selectedRows="getSelectedRows.length"></bulkActions>
            </b-col>
            <b-col sm="10">
                <b-pagination
                    :total-rows="tableRows"
                    v-model="currentPage"
                    :per-page="perPage"
                    align="fill"
                ></b-pagination>
                <span style="font-weight: bold;">
                    {{ $t('history.label.ShowingShipments') }} {{ paginationIndex + 1 }}-{{
                    paginationIndex + perPage > totalRows
                    ? totalRows
                    : paginationIndex + perPage
                    }}
                    {{ $t('history.label.Of') }} {{ totalRows }}
                </span>
            </b-col>
        </b-row>
    </div>
</template>
<script>
  import store from '../../store';
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '../../store/constants';
  import { mapGetters } from 'vuex';
  import HistoryAction from '../History/historyActions';
  import bulkActions from '../History/historyBulkActions';
  import _ from 'lodash';
  import {BOOKING_TYPES} from "@/store/nameConstants";

  export default {
      components: {
          historyAction: HistoryAction,
          bulkActions,
      },

      props: {
          items: { type: Array, required: true },
      },
      data() {
          return {
              totalRows: 1,
              debounceValue: 1000,
              currentPage: 1,
              perPage: 50,
              rows: [],
              filter: null,
              isBusy: false,
              filteredShipments: [],
          };
      },

      watch: {
          items(newVal, oldVal) {
              this.rows = newVal;
              this.totalRows = newVal.length;
          },
      },

      computed: {
        BOOKING_TYPES() {
          return BOOKING_TYPES
        },
          ...mapGetters('history', ['getSelectedRows']),
          tableRows: {
              get() {
                  return this.totalRows;
              },
              set(newValue) {
                  this.totalRows = newValue;
              },
          },

          isAllSelected: {
              get() {
                  return (
                      this.getSelectedRows.length == this.rows.length ||
                      (this.filteredShipments.length > 0 &&
                          this.getSelectedRows.length > 0 &&
                          this.filteredShipments.length == this.getSelectedRows.length)
                  );
              },
              set(newValue) {
                  this.allSelected = newValue;
              },
          },

          paginationIndex() {
              return this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.perPage;
          },

          fields() {
              return [
                  { key: 'select', label: '', thClass: 'min-width' },
                  { key: 'dateAwb', label: 'Date AWB', sortable: false, sortDirection: 'desc' },
                  {
                      key: 'transportProduct',
                      label: 'Transport Product Product',
                      sortable: false,
                      sortDirection: 'desc',
                  },
                  {
                      key: 'shipFromCompanyAccount',
                      label: 'Ship from company Account',
                      sortable: true,
                      sortDirection: 'desc',
                  },
                  {
                      key: 'shipToCompanyCountry',
                      label: 'Ship to company Country',
                      sortable: true,
                      sortDirection: 'desc',
                  },
                  {
                      key: 'sendersReceiversReference',
                      label: 'Senders Reference Receivers Reference',
                      sortable: false,
                      sortDirection: 'desc',
                  },
                  {
                      key: 'actions',
                      label: 'Actions',
                      sortable: false,
                      thClass: 'actions-width',
                  },
              ];
          },
      },

      methods: {
          displayTrackMessage(row) {
              row.toggleDetails();
              return true;
          },
          isSelected(item) {
              return this.getSelectedRows.includes(item);
          },
          selectAll(value) {
              if (value) {
                  this.filteredShipments.length === 0
                      ? this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, [
                            ...this.rows,
                        ])
                      : this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, [
                            ...this.filteredShipments,
                        ]);
              } else {
                  this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, []);
              }
          },
          select(row) {
              const getSelectedRowsCopy = [...this.getSelectedRows];
              getSelectedRowsCopy.includes(row)
                  ? getSelectedRowsCopy.splice(getSelectedRowsCopy.indexOf(row), 1)
                  : getSelectedRowsCopy.push(row);
              this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS,
                  getSelectedRowsCopy
              );
          },
          onFiltered(filteredItems) {
              // Trigger pagination to update the number of buttons/pages due to filtering
              if (this.isAllSelected) {
                  this.isAllSelected = false;
              }
              if (filteredItems.length) {
                  this.totalRows = filteredItems.length;
              }
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_SELECTED_ROWS, []);
              this.filteredShipments = filteredItems;
              this.currentPage = 1;
              this.isBusy = false;
          },

          sortingChanged(ctx) {
              if (ctx.sortBy === 'shipFromCompanyAccount') {
                  this.rows = this.$_.orderBy(
                      this.rows,
                      [(x) => x.senderName.toUpperCase().trim()],
                      [ctx.sortDesc ? 'desc' : 'asc']
                  );
              }
              if (ctx.sortBy === 'shipToCompanyCountry') {
                  this.rows = this.$_.orderBy(
                      this.rows,
                      [(x) => x.receiverName.toUpperCase().trim()],
                      [ctx.sortDesc ? 'desc' : 'asc']
                  );
              }
          },

          toggleBusy() {
              this.isBusy = true;
          }
      },

      mounted() {
          this.totalRows = this.items.length;
          this.rows = this.items;
          this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
      },
  };
</script>

<style>
  .actions-width {
      width: 16% !important;
  }

  .min-width {
      width: 3% !important;
  }

  a:visited {
      color: #005abb;
  }
</style>
